import { Box } from '@chakra-ui/react';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { EllipsisLoading } from 'src/components/loadings';
import { CheckoutRoutes } from './Checkout/Routes';

const Root = lazy(
  () =>
    import(
      /* webpackChunkName: "Event/root" */
      './Root'
    ),
);

export const EventRoutes = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path="checkout/*" element={<CheckoutRoutes />} />
      <Route
        index
        element={
          <Suspense
            fallback={
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%,-50%)">
                <EllipsisLoading color="brand.500" />
              </Box>
            }>
            <Root />
          </Suspense>
        }
      />

      <Route
        path="*"
        element={
          <Navigate
            to={{
              pathname: location.pathname,
              search: location.search,
            }}
          />
        }
      />
    </Routes>
  );
};
